<script setup lang="ts">
  const { loggedIn } = useUserSession()

  // Redirect if already logged in
  if (loggedIn.value) {
    navigateTo('/todos')
  }

  const form = reactive({
    email: '',
    password: '',
  })

  const pending = ref(false)
  const error = ref('')

  async function login() {
    try {
      pending.value = true
      error.value = ''

      await $fetch('/api/auth/login', {
        method: 'POST',
        body: form,
      })

      await navigateTo('/todos')
    } catch (err: any) {
      error.value = err.data?.message || 'Login failed'
    } finally {
      pending.value = false
    }
  }
</script>

<template>
  <div class="max-w-md mx-auto">
    <h1 class="text-2xl font-bold mb-6">Login</h1>

    <form @submit.prevent="login" class="space-y-4">
      <UFormGroup label="Email">
        <UInput
          v-model="form.email"
          type="email"
          placeholder="Enter your email"
          required
        />
      </UFormGroup>

      <UFormGroup label="Password">
        <UInput
          v-model="form.password"
          type="password"
          placeholder="Enter your password"
          required
        />
      </UFormGroup>

      <UAlert
        v-if="error"
        color="error"
        variant="soft"
        :title="error"
        class="mb-4"
      />

      <UButton type="submit" :loading="pending" block> Login </UButton>
    </form>

    <div class="mt-6 text-center space-y-3">
      <p class="text-sm text-gray-600">
        <NuxtLink
          to="/forgot-password"
          class="text-primary-600 hover:text-primary-500"
        >
          Forgot your password?
        </NuxtLink>
      </p>

      <p class="text-sm text-gray-600">
        Don't have an account?
        <NuxtLink
          to="/register"
          class="text-primary-600 hover:text-primary-500"
        >
          Sign up
        </NuxtLink>
      </p>

      <UDivider label="or" class="my-4" />

      <UButton
        to="/api/auth/github"
        icon="i-simple-icons-github"
        label="Continue with GitHub"
        color="neutral"
        variant="outline"
        external
        block
      />
    </div>
  </div>
</template>
